import React from 'react'
import type { DataTableProps } from '@ztechapps/webui.data-tools'
import { DataTable } from '@ztechapps/webui.data-tools'
import type { UnitOfMeasure } from '@ztechapps/common.contract'
import { useUnitOfMeasureContext } from './Context'
import { unitOfMeasureListFieldConfig } from './constants'
import { ListRow } from './ListRow'
import { ListHeader } from './ListHeader'

export const UnitOfMeasureList = (props: Partial<DataTableProps<UnitOfMeasure>>) => {
  const { unitOfMeasureList } = useUnitOfMeasureContext()

  return (
    <DataTable
      fields={unitOfMeasureListFieldConfig}
      listResult={unitOfMeasureList}
      row={ListRow}
      head={ListHeader}
      tableOptions={{ responsive: true }}
      {...props}
    />
  )
}
